import React from 'react';
import ForgotPasswordFormContainer from './ForgotPasswordFormContainer';

const ForgotPasswordPage = () => (
  <div className="container no-sidebar">
    <div className="row">
      <div className="col-md-6 col-md-offset-3">
        <div className="card card-block">
          <h2 className="card-title">Reset Password</h2>
          <ForgotPasswordFormContainer />
        </div>
      </div>
    </div>
  </div>
);

export default ForgotPasswordPage;
